import React, {useEffect, useState} from "react";
import Select from "react-select";

import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import facilityIcon from "../../../../../resources/images/facility-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {
    retrieveProvincesForDropdown,
    retrieveDistrictsForDropdown,
    retrieveSubDistrictsForDropdown,
    retrieveFacilitiesForDropdown, retrieveCountriesForDropdown, viewLocation
} from "../../../../../services/FacilityService";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {convertDateToUTC} from "../../../../../util/DateUtil";
import {updateProblem} from "../../../../../services/ProblemService";

export const FacilitySearch = ({context, setContext, navigateTo, navigateBack, setSpinnerText, showToaster}) => {

    const [levelOfSupport, setLevelOfSupport] = useState({value: null, label: "Select..."});
    const [country, setCountry] = useState({value: null, label: "Select..."});
    const [province, setProvince] = useState({value: null, label: "Select..."});
    const [district, setDistrict] = useState({value: null, label: "Select..."});
    const [subDistrict, setSubDistrict] = useState({value: null, label: "Select..."});
    const [facility, setFacility] = useState({value: null, label: "Select..."});
    const [levelOfSupportList] = useState([
        {value: 1, label: "National"},
        {value: 2, label: "Provincial"},
        {value: 3, label: "District"},
        {value: 4, label: "Sub District"},
        {value: 5, label: "Facility"},
    ]);
    const [countryList, setCountryList] = useState([]);
    const [provinceList, setProvinceList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [subDistrictList, setSubDistrictList] = useState([]);
    const [facilityList, setFacilityList] = useState([]);

    useEffect(() => {
        if (!context.viewMode) {
            setContext((prevState) => ({
                ...prevState,
                breadcrumbs: {
                    ...prevState.breadcrumbs,
                    facilityBreadcrumb: {
                        ...prevState.breadcrumbs.facilityBreadcrumb,
                        type: "Location",
                        screenKey: "facilitySelect"
                    }
                },
            }));
        }
    }, []);

    useEffect(() => {
        if (context.facilityScreen) {
            if (context.facilityScreen.levelOfSupport) {
                setLevelOfSupport(context.facilityScreen.levelOfSupport);
            }

            if (context.facilityScreen.country) {
                setCountry(context.facilityScreen.country);
            }

            if (context.facilityScreen.province) {
                setProvince(context.facilityScreen.province);
            }

            if (context.facilityScreen.district) {
                setDistrict(context.facilityScreen.district);
            }

            if (context.facilityScreen.subDistrict) {
                setSubDistrict(context.facilityScreen.subDistrict);
            }

            if (context.facilityScreen.province && context.facilityScreen.facility) {
                setFacility(context.facilityScreen.facility);
            }
        }
    }, [context]);

    useEffect(() => {
        if (levelOfSupport.value) {
            setSpinnerText("Retrieving Countries");
            const fetchData = async () => {
                const [data] = await retrieveCountriesForDropdown(context.username);
                if (data) {
                    if (data.responseStatus === "Success") {
                        const countryList = [];
                        const resultMap = data.resultMap;
                        for (const property in resultMap) {
                            countryList.push({value: property, label: resultMap[property]});
                        }
                        setCountryList(countryList);
                    }
                }
                setSpinnerText(null);
            }
            fetchData();
        }
    }, [levelOfSupport]);

    useEffect(() => {
        if (country.value && levelOfSupport.value > 1) {
            setSpinnerText("Retrieving Provinces");
            const fetchData = async () => {
                const [data] = await retrieveProvincesForDropdown(context.username, country.label);
                if (data) {
                    if (data.responseStatus === "Success") {
                        const provinceList = [];
                        const resultMap = data.resultMap;
                        for (const property in resultMap) {
                            provinceList.push({value: property, label: resultMap[property]});
                        }
                        setProvinceList(provinceList);
                    } else {
                        setProvinceList([]);
                    }
                } else {
                    setProvinceList([]);
                }
                setSpinnerText(null);
            }
            fetchData();
        }
    }, [country]);

    useEffect(() => {
        if (province.value && levelOfSupport.value > 2) {
            setSpinnerText("Retrieving Districts");
            const fetchData = async () => {
                const [data] = await retrieveDistrictsForDropdown(context.username, country.label, province.label);
                if (data) {
                    if (data.responseStatus === "Success") {
                        const districtList = [];
                        const resultMap = data.resultMap;
                        for (const property in resultMap) {
                            districtList.push({value: property, label: resultMap[property]});
                        }
                        setDistrictList(districtList);
                    } else {
                        setDistrictList([]);
                    }
                } else {
                    setDistrictList([]);
                }
                setSpinnerText(null);
            }
            fetchData();
        }
    }, [province]);

    useEffect(() => {
        if (district.value && levelOfSupport.value > 3) {
            setSpinnerText("Retrieving Sub Districts");
            const fetchData = async () => {
                const [data] = await retrieveSubDistrictsForDropdown(context.username, country.label, province.label, district.label);
                if (data) {
                    if (data.responseStatus === "Success") {
                        const subDistrictList = [];
                        const resultMap = data.resultMap;
                        for (const property in resultMap) {
                            subDistrictList.push({value: property, label: resultMap[property]});
                        }
                        setSubDistrictList(subDistrictList);
                    } else {
                        setSubDistrictList([]);
                    }
                } else {
                    setSubDistrictList([]);
                }
                setSpinnerText(null);
            }
            fetchData();
        }
    }, [district]);

    useEffect(() => {
        if (subDistrict.value && levelOfSupport.value > 4) {
            setSpinnerText("Retrieving Facilities");
            const fetchData = async () => {
                const [data] = await retrieveFacilitiesForDropdown(context.username, country.label, province.label, district.label, subDistrict.label);
                if (data) {
                    if (data.responseStatus === "Success") {
                        const facilityList = [];
                        const resultMap = data.resultMap;
                        for (const property in resultMap) {
                            facilityList.push({value: property, label: resultMap[property]});
                        }
                        setFacilityList(facilityList);
                    } else {
                        setFacilityList([]);
                    }
                } else {
                    setFacilityList([]);
                }
                setSpinnerText(null);
            }
            fetchData();
        }
    }, [subDistrict]);

    const handleNextClick = async () => {
        let locationBreadCrumbText;
        let location;
        if (levelOfSupport.value === 1) {
            locationBreadCrumbText = country.label;
            location = {
                country: country.label,
                province: "",
                district: "",
                subDistrict: "",
                facility: "",
                active: true,
            }
        } else if (levelOfSupport.value === 2) {
            locationBreadCrumbText = province.label;
            location = {
                country: country.label,
                province: province.label,
                district: "",
                subDistrict: "",
                facility: "",
                active: true,
            }
        } else if (levelOfSupport.value === 3) {
            locationBreadCrumbText = district.label;
            location = {
                country: country.label,
                province: province.label,
                district: district.label,
                subDistrict: "",
                facility: "",
                active: true,
            }
        } else if (levelOfSupport.value === 4) {
            locationBreadCrumbText = subDistrict.label;
            location = {
                country: country.label,
                province: province.label,
                district: district.label,
                subDistrict: subDistrict.label,
                facility: "",
                active: true,
            }
        } else {
            locationBreadCrumbText = facility.label;
            location = {
                country: country.label,
                province: province.label,
                district: district.label,
                subDistrict: subDistrict.label,
                facility: facility.label,
                active: true,
            }
        }
        const [data] = await viewLocation(context.username, location);
        if (data) {
            if (data.responseStatus === "Success") {
                const retrievedLocation = data.foundLocationVO;
                if (!context.viewMode) {
                    setContext((prevState) => ({
                        ...prevState,
                        facilityScreen: {
                            ...prevState.facilityScreen,
                            levelOfSupport,
                            locationBreadCrumbText,
                            locationExternalReference: retrievedLocation.externalReference,
                        }
                    }));
                } else {
                    setContext((prevState) => ({
                        ...prevState,
                        facilityScreen: {
                            levelOfSupport,
                            locationExternalReference: retrievedLocation.externalReference,
                            country: {label: retrievedLocation.country, value: retrievedLocation.country},
                            province: {label: retrievedLocation.province, value: retrievedLocation.province},
                            district: {label: retrievedLocation.district, value: retrievedLocation.district},
                            subDistrict: {label: retrievedLocation.subDistrict, value: retrievedLocation.subDistrict},
                            facility: {label: retrievedLocation.facility, value: retrievedLocation.facility},
                        }
                    }));

                    const problemToBeSaved = {
                        externalReference: context.problemScreen.externalReference,
                        topicAreaExternalRef: context.topicAreaScreen.topicArea.externalReference,
                        locationExternalRef: retrievedLocation.externalReference,
                        visitExternalRef: context.topicAreaScreen.visitExternalReference,
                        name: context.problemScreen.title,
                        description: context.problemScreen.description,
                        reviewFrequency: context.problemScreen.frequency.label,
                        aimStatementVO: {
                            toImprove: context.problemScreen.toImprove,
                            from: context.problemScreen.from,
                            to: context.problemScreen.to,
                            by: convertDateToUTC(context.problemScreen.byDate),
                        },
                        outcomeMeasureBaselines: context.problemScreen.baselines,
                        levelOfSupport: levelOfSupport.label,
                        grantExternalRef: context.topicAreaScreen.grant.externalReference,
                        dateOfNextVisit: convertDateToUTC(context.problemScreen.nextVisitDate),
                    };

                    if (retrievedLocation.externalReference !== context.facilityScreen.locationExternalReference) {
                        const [data, error] = await updateProblem(context.username, problemToBeSaved);
                        if (data) {
                            showToaster({
                                responseStatus: "Success",
                                responseMessage: "Location Updated",
                            });
                        } else {
                            showToaster({
                                responseStatus: "Error",
                                responseMessage: error.message,
                            });
                        }
                    }
                }
                navigateTo("topicAreaOne");
            } else {
                showToaster(data);
            }
        }
    }

    const isButtonDisabled = () => {
        switch (levelOfSupport.value) {
            case 1:
                return !country.value;
            case 2:
                return !province.value;
            case 3:
                return !district.value;
            case 4:
                return !subDistrict.value;
            case 5:
                return !facility.value;
            default:
                return true;
        }
    }

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={facilityIcon} alt="Aurum Logo" className="wizard-icon"/>
                    </div>
                </div>
                <div className="wizard-right-container">
                    <div className="facility-search-form-container">
                        <div className="input-container">
                            <label>Level Of Support:</label>
                            <Select options={levelOfSupportList}
                                    onChange={(selectedLevelOfSupport) => {
                                        setLevelOfSupport(selectedLevelOfSupport);
                                        setCountry({value: null, label: "Select..."});
                                        setProvince({value: null, label: "Select..."});
                                        setDistrict({value: null, label: "Select..."});
                                        setSubDistrict({value: null, label: "Select..."});
                                        setFacility({value: null, label: "Select..."});
                                    }}
                                    value={levelOfSupport}
                                    classNamePrefix="select"
                                    isDisabled={!context.editMode}
                            />
                        </div>
                        {levelOfSupport.value && <div className="input-container">
                            <label>Country:</label>
                            <Select options={countryList}
                                    onChange={(selectedCountry) => {
                                        setCountry(selectedCountry);
                                        setProvince({value: null, label: "Select..."});
                                        setDistrict({value: null, label: "Select..."});
                                        setSubDistrict({value: null, label: "Select..."});
                                        setFacility({value: null, label: "Select..."});
                                    }}
                                    value={country}
                                    classNamePrefix="select"
                                    isDisabled={!context.editMode}
                            />
                        </div>}
                        {(levelOfSupport.value > 1) && <div className="input-container">
                            <label>Province:</label>
                            <Select options={provinceList}
                                    onChange={(selectedProvince) => {
                                        setProvince(selectedProvince);
                                        setDistrict({value: null, label: "Select..."});
                                        setSubDistrict({value: null, label: "Select..."});
                                        setFacility({value: null, label: "Select..."});
                                    }}
                                    isDisabled={!country.value || !context.editMode}
                                    value={province}
                                    classNamePrefix="select"
                            />
                        </div>}
                        {(levelOfSupport.value > 2) && <div className="input-container">
                            <label>District:</label>
                            <Select options={districtList}
                                    onChange={(selectedDistrict) => {
                                        setDistrict(selectedDistrict);
                                        setSubDistrict({value: null, label: "Select..."});
                                        setFacility({value: null, label: "Select..."});
                                    }}
                                    isDisabled={!province.value || !context.editMode}
                                    value={district}
                                    classNamePrefix="select"
                            />
                        </div>}
                        {(levelOfSupport.value > 3) && <div className="input-container">
                            <label>Sub-District:</label>
                            <Select options={subDistrictList}
                                    onChange={(selectedSubDistrict) => {
                                        setSubDistrict(selectedSubDistrict);
                                        setFacility({value: null, label: "Select..."});
                                    }}
                                    isDisabled={!district.value || !context.editMode}
                                    value={subDistrict}
                                    classNamePrefix="select"
                            />
                        </div>}
                        {(levelOfSupport.value > 4) && <div className="input-container">
                            <label>Facility:</label>
                            <Select options={facilityList}
                                    onChange={(selectedFacility) => {
                                        setFacility(selectedFacility)
                                    }}
                                    isDisabled={!subDistrict.value || !context.editMode}
                                    value={facility}
                                    classNamePrefix="select"
                            />
                        </div>}
                        {context.viewMode && <div className="back-to-overview-button-container">
                            <StandardButton text="Problem Overview" onClick={() => {
                                navigateTo("problemTree");
                            }}/>
                        </div>}
                        <div className="navigation-button-container">
                            <NextButton disabled={isButtonDisabled()} onClick={handleNextClick}/>
                            <BackButton onClick={navigateBack}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>
        </div>
    );
}
